import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Modal, Validators } from '@softline/ui-core';
import { Subkunde } from '../../types/subkunde';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { InputComponent } from '@softline/ui-core';
import { ToggleSwitchComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-create-subkunde-dialog',
    imports: [ReactiveFormsModule,
    InputComponent,
    ToggleSwitchComponent,
    TranslatePipe],
    templateUrl: './create-subkunde-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./create-subkunde-dialog.component.css']
})
export class CreateSubkundeDialogComponent
  implements OnInit, Modal<Partial<Subkunde>>
{
  form = new FormGroup({
    kostenstelle: new FormControl(''),
    name: new FormControl('', [Validators.required()]),
    aktiv: new FormControl(true, [Validators.required()]) });

  private close!: (subkunde: Partial<Subkunde>) => void;

  constructor() {}

  ngOnInit(): void {}

  registerCloseHandler(handler: (result: Partial<Subkunde>) => void): void {
    this.close = handler;
  }

  onSubmit(value: Partial<Subkunde>): void {
    this.close(value);
  }
}
